import { USER_IDENTITY_CONFIG } from '@/constants/constantsAckoDrive';

export const REFRESH_JWT_TOKENS = 'api/refresh-tokens';
export const TOKEN_VERIFY_URL = 'api/token/verify/';

const ACKO_DRIVE_ENDPOINT = process.env.NEXT_PUBLIC_ACKO_DRIVE_API_IP;

type PostRequestResult<T> = {
    success: boolean;
    data?: T;
    error?: string;
};

class AuthService {
    private baseURL?: string;
    private clientId?: string;

    constructor() {
        this.baseURL = ACKO_DRIVE_ENDPOINT;
        this.clientId = USER_IDENTITY_CONFIG.CLIENT_ID;
    }

    private async postRequest<T>(
        endpoint: string,
        payload: Record<string, any>
    ): Promise<PostRequestResult<T>> {
        const url = `${this.baseURL}/${endpoint}`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data: T = await response.json();
            return { success: true, data };
        } catch (error) {
            console.error(`Error in POST request to ${endpoint}:`, error);
            return { success: false, error: (error as Error).message };
        }
    }

    public async getNewAccessToken(
        refreshToken: string
    ): Promise<Record<string, any> | null> {
        const payload = {
            refresh_token: refreshToken,
            grant_type: 'refresh_token',
            client_id: this.clientId,
        };
        const result: any = await this.postRequest<Record<string, any>>(
            REFRESH_JWT_TOKENS,
            payload
        );
        return result.success ? result.data : null;
    }

    public async getAccessToken(
        refreshToken: string
    ): Promise<PostRequestResult<Record<string, any>>> {
        const payload = {
            refresh_token: refreshToken,
            grant_type: 'refresh_token',
            client_id: this.clientId,
        };
        return await this.postRequest<Record<string, any>>(
            REFRESH_JWT_TOKENS,
            payload
        );
    }

    // public async verifyToken(
    //   token: string
    // ): Promise<PostRequestResult<Record<string, any>>> {
    //   const payload = { token };
    //   return await this.postRequest<Record<string, any>>(TOKEN_VERIFY_URL, payload);
    // }
}

export default new AuthService();
